<template>
  <div class="box">
    <div class="box-header">
      <h3>Email Setting</h3>
    </div>
    <div class="box-body">
      <div class="grids is-2-desktop gap-20-desktop">
        <div class="field no-margin">
          <label for="" class="label">
            Expired Job Notification Email<span>*</span>
          </label>
          <div class="control" v-for="(i, index) in form.notifyExpire" :key="index">
            <input type="text" class="input" placeholder="Email" v-model="form.notifyExpire[index]" />
            <i class="fas fa-trash" style="cursor: pointer" @click="form.notifyExpire.splice(index, 1)"></i>
          </div>
          <button type="button" class="button primary" v-if="form.notifyExpire.length < 10"
            @click="form.notifyExpire.push('')">
            Add Email
          </button>
        </div>
        <div class="field no-margin">
          <label for="" class="label">
            Post Job Complete Notification Email <span>*</span>
          </label>
          <div class="control" v-for="(i, index) in form.nortificationEmails" :key="index">
            <input type="text" class="input" placeholder="Email" v-model="form.nortificationEmails[index]" />
            <i class="fas fa-trash" style="cursor: pointer" @click="form.nortificationEmails.splice(index, 1)"
              v-if="index !== 0"></i>
          </div>
          <button type="button" class="button primary" v-if="form.nortificationEmails.length < 10"
            @click="form.nortificationEmails.push('')">
            Add Email
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["info"],
  data: () => ({
    form: {
      nortificationEmails: [],
      notifyExpire: []
    }
  }),
  watch: {
    form: {
      handler(val) {
        if (val) {
          this.$emit('input', val)
        }
      },
      immediate: true,
    },
    "info": {
      handler(val) {
        if (val) {
          this.form.nortificationEmails = val.nortificationEmails
          this.form.notifyExpire = val.notifyExpire
        }
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.input {
  margin: 2px;
}
</style>
